export default __webpack_public_path__ + "static/christmas_2020-f695b565567e7de08eac2cd7a0c93520.jpg";